import { render, staticRenderFns } from "./StoryTestplan.vue?vue&type=template&id=347fb57d"
import script from "./StoryTestplan.vue?vue&type=script&lang=js"
export * from "./StoryTestplan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports